import {storeToRefs} from 'pinia';
import {set} from '@vueuse/core';
import {HYPERMARKET_CHANGE_FLAG_COOKIE} from '#shared/constants';
import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';

export default defineNuxtRouteMiddleware((to) => {
	if (import.meta.server) {
		const hypermarketsStore = useStoryblokHypermarketsStore();
		const {hypermarketsBySlug, selectedHypermarket} = storeToRefs(hypermarketsStore);

		if (to.query?.hm && String(to.query.hm) in hypermarketsBySlug.value) {
			if (to.query.hm !== selectedHypermarket.value) {
				const hypermarketChangedFlag = useCookie(HYPERMARKET_CHANGE_FLAG_COOKIE, {default: () => false});
				hypermarketChangedFlag.value = true;
			}

			set(selectedHypermarket, to.query.hm);
			delete to.query.hm;
			return navigateTo(to, {redirectCode: 303});
		}
	}
});
